import { Action } from 'redux';

import { SiteActivate, SiteDelete, SiteEdit, SiteSuspend } from '../../bootstrap/redux/actions/AppActionTypes';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';

export interface SiteMenuAction extends Action {
  items: ISiteSettingsForServerAdmin[];
}

export function suspendSite(items: ISiteSettingsForServerAdmin[]): SiteMenuAction {
  return {
    type: SiteSuspend,
    items
  };
}

export function activateSite(items: ISiteSettingsForServerAdmin[]): SiteMenuAction {
  return {
    type: SiteActivate,
    items
  };
}

export function editSite(items: ISiteSettingsForServerAdmin[]): SiteMenuAction {
  return {
    type: SiteEdit,
    items
  };
}

export function deleteSite(items: ISiteSettingsForServerAdmin[]): SiteMenuAction {
  return {
    type: SiteDelete,
    items
  };
}
